import "../../../../theme/global.css"
import "../../client-dashboard/messaging/style.css"
import trash from "../../../../images/delete.svg"
import prevArrow from "../../../../images/back_arrow_fade.svg"
import nextArrow from "../../../../images/forward_arrow.svg"
import { Link } from "react-router-dom"
import { ComponentState, useState } from "react"
import { MessageCompose } from "./components/compose-message"
import { Modal } from "@mui/material"
import { InboxMessaging } from "./components/inbox-messages"
import { SentMessage } from "./components/sent-message"
import { TrashMessages } from "./components/trash-message"
import composeIcon from "../../../../images/mail-edit-01.png"
import deleteIcon from "../../../../images/trash2.png";
import sentIcon from "../../../../images/send.png";
import inboxIcon from "../../../../images/inbox (1).png";
import { useDispatch, useSelector } from "react-redux"
import { setMessageListToBack } from "../../../../redux/actions"


export const Messaging = () => {
  const [showCompose, setShowCompose] = useState(false)
  const [currentOperation, setCurrentOperations] = useState(0)
  const [selectedTab, setSelectedTab] = useState(0);
  const state: ComponentState = useSelector(states => {
    return states;
});
  const { messageCounter} = state['MessagesReducer'];
   const dispatch=useDispatch()

  return (
    <>
      <Modal
        open={showCompose}
        onClose={() => { }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MessageCompose onClose={() => setShowCompose(false)} title="Message" tabId={-1} />
      </Modal>

      <section className="message-wrapper pt-2 my-5">
        <div className="container-fluid">
          {/* <h2 className="fw-700">Inbox</h2> */}
          {/* <div className="d-flex justify-content-between w-100 my-4 flex-wrap outerFlex">
          
          <div className="d-flex align-items-center drop-wrapper justify-content-between "> 
            <h6 className="m-0">Entries</h6>
            <div className="dropdown">
              <button className="btn btn_toggle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                10
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a className="dropdown-item" href="#">70</a>
                <a className="dropdown-item" href="#">70</a>
                <a className="dropdown-item" href="#">70</a>
              </div>
            </div>
          </div> 
          <div className="position-relative searchBox  ">
            <div className="searchIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <path d="M16.031 14.617L20.314 18.899L18.899 20.314L14.617 16.031C13.0237 17.3082 11.042 18.0029 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18.0029 11.042 17.3082 13.0237 16.031 14.617ZM14.025 13.875C15.2941 12.5699 16.0029 10.8204 16 9C16 5.133 12.867 2 9 2C5.133 2 2 5.133 2 9C2 12.867 5.133 16 9 16C10.8204 16.0029 12.5699 15.2941 13.875 14.025L14.025 13.875Z" fill="#048373" />
              </svg>
            </div>
            <input type="text" className="form-control" placeholder="Search here" />
          </div>
        </div>*/}
        </div>
      </section>

      <section className="message-inner">
        <div className="row justify-content-around container-fluid">
          <div className="inner-dt col-lg-3 col-md-12 col-sm-12 bgSmokey">
            <div className="col-12 message-sidebar">
              <ul>
                <span
                  onClick={() => setShowCompose(true)}
                  className="btn blue-primary text-white mt-4 d-inline-flex mb-3" style={{ fontSize: "16px", fontWeight: "500" }}
                >
                  <img src={composeIcon} alt="New Message" className="mr-2" /> New Message
                </span>
                <li className={`staff-text mb-3 inboxHeader d-flex justify-content-between align-items-center ${selectedTab === 0 ? 'selected' : ''}`}
                  onClick={() => {
                    setCurrentOperations(0);
                    setSelectedTab(0);
                    dispatch(setMessageListToBack(1))
                  }}>
                  <div className="d-flex align-items-center">
                    <img src={inboxIcon} alt="inbox" className="pr-2" />
                    <span>Inbox</span>
                  </div>
                  {(messageCounter && messageCounter>0 && messageCounter!==0 )?
                  <span className="count_number"> {messageCounter} </span>:''}
                </li>

                <li className={`staff-text mb-3 sendHeader 
                ${selectedTab === 1 ? 'selected' : ''}`}
                  onClick={() => {
                    setCurrentOperations(1);
                    setSelectedTab(1);
                    dispatch(setMessageListToBack(1))
                  }}>
                  {/* <Link to="/sent" className="d-flex align-items-center gap w-100">
                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 50 50" fill="none">
                        <rect width="50" height="50" rx="12" fill="#2EC8EC" />
                        <path d="M33.4849 18.46C33.2201 18.1947 32.7904 18.1943 32.5256 18.4589L24.3872 26.5758L21.4509 23.3867C21.1972 23.1113 20.7682 23.0934 20.4923 23.3471C20.2167 23.6008 20.199 24.03 20.4527 24.3057L23.8673 28.014C23.9292 28.0812 24.004 28.1353 24.0873 28.1728C24.1706 28.2104 24.2606 28.2308 24.3519 28.2327C24.3569 28.2329 24.3617 28.2329 24.3664 28.2329C24.5459 28.2328 24.7181 28.1617 24.8453 28.035L33.4835 19.4194C33.749 19.1549 33.7495 18.7252 33.4849 18.46Z" fill="white" />
                        <path d="M33.3216 24.3216C32.9469 24.3216 32.6432 24.6253 32.6432 25C32.6432 29.2146 29.2146 32.6432 25 32.6432C20.7856 32.6432 17.3568 29.2146 17.3568 25C17.3568 20.7856 20.7856 17.3568 25 17.3568C25.3747 17.3568 25.6784 17.0531 25.6784 16.6784C25.6784 16.3037 25.3747 16 25 16C20.0373 16 16 20.0373 16 25C16 29.9624 20.0373 34 25 34C29.9624 34 34 29.9624 34 25C34 24.6253 33.6963 24.3216 33.3216 24.3216Z" fill="white" />
                      </svg> */}
                  {/* <span>Sent</span> */}
                  <img src={sentIcon} alt="sent" /> Sent
                  {/* </Link> */}
                </li>

                <li className="staff-text mb-3 sendHeader k-selected" onClick={() => {
                   dispatch(setMessageListToBack(1))
                  setCurrentOperations(2)}}>
                  {/* <Link to="/sent" className="d-flex align-items-center gap w-100">
                      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 50 50" fill="none">
                        <rect width="50" height="50" rx="12" fill="#2EC8EC" />
                        <path d="M33.4849 18.46C33.2201 18.1947 32.7904 18.1943 32.5256 18.4589L24.3872 26.5758L21.4509 23.3867C21.1972 23.1113 20.7682 23.0934 20.4923 23.3471C20.2167 23.6008 20.199 24.03 20.4527 24.3057L23.8673 28.014C23.9292 28.0812 24.004 28.1353 24.0873 28.1728C24.1706 28.2104 24.2606 28.2308 24.3519 28.2327C24.3569 28.2329 24.3617 28.2329 24.3664 28.2329C24.5459 28.2328 24.7181 28.1617 24.8453 28.035L33.4835 19.4194C33.749 19.1549 33.7495 18.7252 33.4849 18.46Z" fill="white" />
                        <path d="M33.3216 24.3216C32.9469 24.3216 32.6432 24.6253 32.6432 25C32.6432 29.2146 29.2146 32.6432 25 32.6432C20.7856 32.6432 17.3568 29.2146 17.3568 25C17.3568 20.7856 20.7856 17.3568 25 17.3568C25.3747 17.3568 25.6784 17.0531 25.6784 16.6784C25.6784 16.3037 25.3747 16 25 16C20.0373 16 16 20.0373 16 25C16 29.9624 20.0373 34 25 34C29.9624 34 34 29.9624 34 25C34 24.6253 33.6963 24.3216 33.3216 24.3216Z" fill="white" />
                      </svg> */}
                  {/* <span>Trash</span> */}
                  <img src={deleteIcon} alt="trash" className="delBtn pl-1" /> Trash
                  {/* </Link> */}
                </li>
              </ul>
            </div>
          </div>
          <div className="inner-dt col-lg-8 col-md-12 col-sm-12" >
            <div className="col-12">
              {currentOperation === 0 ? <InboxMessaging /> : (currentOperation === 1) ? <SentMessage></SentMessage> : <TrashMessages />}

              {/* <table className="table messgaeTable mb-0">
                <thead>
                  <tr>
                    <th>From</th>
                    <th>To</th>
                    <th>Subject</th>
                    <th>Sent</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody style={{ padding: "auto 10px auto 10px" }}>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                  <tr >
                    <td>#1234567890</td>
                    <td>21-11-2023</td>
                    <td>Vorem ipsum dolor </td>
                    <td className="td_link"><a href="">#View Document</a> </td>
                    <td><button><img src={trash} alt="" /></button></td>
                  </tr>
                </tbody>
               
              </table> */}
              {/* <div className="tablePagination d-flex align-items-center justify-content-between bg-white">
                 
                    <p className="pl-5">Showing <span>1 to 10 </span>of <span>94</span> Entries</p>
                 
                  <div className="paginationnumber d-flex align-items-center pr-3">
                    <img src={prevArrow} alt=""/>
                  <p> Page <span>1</span></p>
                    <img src={nextArrow} alt=""/>
                  </div>
                </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  )
};